import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Divider} from '@/components/ui/divider/Divider'
import {Text} from '@/components/ui/text/Text'
import {ProjectDetailsInfoSection} from '@/features/projects/components/project-details-info-section/ProjectDetailsInfoSection'
import {ProjectDetailsPatientSection} from '@/features/projects/components/project-details-patient-section/ProjectDetailsPatientSection'
import {ProjectDetailsReferringSpecialistSection} from '@/features/projects/components/project-details-referring-specialist-section/ProjectDetailsReferringSpecialistSection'
import {ProjectDetailsTeamSection} from '@/features/projects/components/project-details-team-section/ProjectDetailsTeamSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PlannedAccessesSection} from '@/features/projects/components/planned-accesses-section/PlannedAccessesSection'
import {CompletedAccessesSection} from '@/features/projects/components/completed-accesses-section/CompletedAccessesSection'
import {RecordedAbsencesSection} from '@/features/projects/components/recorded-absences-section/RecordedAbsencesSection'
import {ProjectDetailsSiarSection} from '@/features/projects/components/project-details-siar-section/ProjectDetailsSiarSection'

export const ProjectDetailsProjectData = () => {
    const {project} = useOutletContext<{project: ProjectExtended; isEditable: boolean}>()
    const {t} = useTranslation()

    return (
        <ScrollArea scrollbar={<Scrollbar />}>
            <DetailsTabContentWrapper>
                <Helmet
                    title={t('projects:project_details_meta_title', {
                        fullName: project.patient.fullName,
                        code: project.code
                    })}
                />
                <Grid columns={2} gap={4}>
                    <ProjectDetailsInfoSection />
                    <ProjectDetailsPatientSection />
                    <ProjectDetailsReferringSpecialistSection />
                    <ProjectDetailsTeamSection />
                    <GridItem spanColumn={2}>
                        <ProjectDetailsSiarSection />
                    </GridItem>
                </Grid>
            </DetailsTabContentWrapper>
            <Divider direction="horizontal" />
            <DetailsTabContentWrapper>
                <Flexbox direction="column" gap={6} fullWidth>
                    <Text palette="neutral" shade="950" size="textLg" weight="500">
                        {t('projects:access_and_absence')}
                    </Text>
                    <Grid columns={3} gap={4} fullWidth>
                        <PlannedAccessesSection />
                        <CompletedAccessesSection />
                        <RecordedAbsencesSection />
                    </Grid>
                </Flexbox>
            </DetailsTabContentWrapper>
        </ScrollArea>
    )
}
